"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FileType;
(function (FileType) {
    FileType["IMAGE"] = "IMAGE";
    FileType["VIDEO"] = "VIDEO";
    FileType["AUDIO"] = "AUDIO";
    FileType["DOCUMENT"] = "DOCUMENT";
    FileType["FOLDER"] = "FOLDER";
})(FileType = exports.FileType || (exports.FileType = {}));
//# sourceMappingURL=FileType.js.map